<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" :key="componentId")
      button.button(slot="trigger" v-if="reservation !== null" ) Charge session
      a.fa-stack.fa-lg(slot="trigger" v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .column
          label Port
            input(type="text", v-model="port_id")
        .column
          label Reservation ID
            input(type="text", v-model="reservation_id" :disabled="reservation")
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel

</template>

<script>
import MaggieHelper from '../../maggieHelper'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import ActionButton from '../../components/structure/ui/ActionButton'
import ModalReveal from '../../components/structure/foundation/ModalReveal'

export default {
  name: 'ChargingSessionReveal',
  components: {ActionButton, ModalReveal},
  data() {
    return {
      port_id: null,
      reservation_id: null,
    }
  },
  created() {
    if (this.reservation !== null) {
      this.reservation_id = this.reservation.id
    }
  },
  methods: {
    save() {
      return KeplerBackofficeSdk.chargingSessions.make({
        port_id: this.port_id,
        reservation_id: this.reservation_id,
      }, () => {
        MaggieHelper.notification('', 'charging session created')

        this.$refs[this.componentId].close()
      })
    }
  },
  computed: {
    componentId() {
      return `chargeReveal-${this._uid}`
    },
  },
  props: {
    reservation: {
      type: Object,
      default: null,
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChargingSessionReveal.vue?edecaad6